import { render, staticRenderFns } from "./Volunteerservicelist.vue?vue&type=template&id=96708692&scoped=true"
import script from "./Volunteerservicelist.vue?vue&type=script&lang=js"
export * from "./Volunteerservicelist.vue?vue&type=script&lang=js"
import style0 from "./Volunteerservicelist.vue?vue&type=style&index=0&id=96708692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96708692",
  null
  
)

export default component.exports